import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faX, faHouse, faGauge, faFolder, faCog, faSignOutAlt, faCircleInfo, faBars, faUserCircle, faPhone, faBuilding, faUserGroup, faLock, faLocationDot, faArrowLeft, faIdCard, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { decryptData, getOrDeleteRequest } from "../../utils/utils";
import { getSession, LogOut, postOrPutRequest } from '../../utils/utils';
import logo from '../../images/logo-fundemas.png'
import { Link, useParams } from 'react-router-dom';
import PrevButton from '../../components/PrevButton';
import MainThemeLayout from '../../layout/MainThemeLayout';

function PreviewCompanyProfile() {
    const [loading, setLoading] = useState(false);
    const [companyId, setCompanyId] = useState(null);
    const { id } = useParams();

    let sesion = getSession();

    const [formulario, setFormulario] = useState({
        company_name: '',
        address: '',
        state_id: '',
        city_id: '',
        district_id: '',
        trade_name: '',
        phone: '',
        business_sectors: '',
        nit: '',
        names: '',
        lastnames: '',
        about_us: '',
        image: '',
    });

    const [userInfo, setUserInfo] = useState({
        userName: "",
        role: "",
    });

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        const sidebar = document.getElementById("Organización");
        sidebar.classList.toggle("hidden");
        document.body.style.overflow = isMenuOpen ? "auto" : "hidden";
        setIsMenuOpen(!isMenuOpen);
    };

    const loadData = () => {
        let userRole = "No especificado";

        if (sesion.type_id === 1) userRole = "Administrador";
        if (sesion.type_id === 4) userRole = "Organización";

        setUserInfo({
            userName: sesion.username,
            role: userRole,
        });
        setCompanyId(id);
        getData(id ?? sesion.company.id);
    };

    const getData = async (id) => {
        let response = await getOrDeleteRequest(`company/find/${id}`, 'GET');

        // console.log(response, 'response');

        let documentType = 'nit';
        if (response.data.dui) documentType = 'dui';
        if (response.data.other_document) documentType = 'other';

        if (response.type === 'success' && response.data) {
            setFormulario({
                company_name: response.data.company_name,
                address: response.data.address,
                state_id: response.data.state_id,
                city_id: response.data.city_id,
                district_id: response.data.district_id,
                trade_name: response.data.trade_name,
                phone: response.data.phone,
                business_sectors: response.data.business_sectors[0]?.name,
                nit: response.data.nit || '',
                dui: response.data.dui || '',
                other_document: response.data.other_document || '',
                document_type: documentType,
                names: response.data.names || '',
                lastnames: response.data.lastnames,
                about_us: response.data.about_us,
                image: response.data.image,
                email: response.data.email || '',
            });
        }
    };

    const renderDocumentInfo = () => {
        switch (formulario.document_type) {
            case 'nit':
                return <InfoIconRow icon={faIdCard} label="NIT" value={formulario.nit} />;
            case 'dui':
                return <InfoIconRow icon={faIdCard} label="DUI" value={formulario.dui} />;
            case 'other':
                return <InfoIconRow icon={faIdCard} label="Documento" value={formulario.other_document} />;
            default:
                return <InfoIconRow icon={faIdCard} label="Documento" value="No especificado" />;
        }
    };

    useEffect(() => {
        setLoading(true);
        loadData();
        setLoading(false);
    }, []);

    return (
        <MainThemeLayout>
            <section className='w-full flex flex-col bg-slate-200 dark:bg-[#1e1e1e] p-2 md:p-4'>
                <div className="py-2 px-4 w-full items-center rounded-lg">
                    <div className='border-b-1 dark:bg-[#292929] rounded-md border-gray-400 w-full py-5 px-5 flex flex-row items-center bg-white justify-between'>
                        <Link to="/Organizaciones" className="text-left">
                            <FontAwesomeIcon icon={faArrowLeft} className="text-turquesa text-xl" />
                        </Link>
                        <div className='flex-1 flex justify-center'>
                            <div className='w-full max-w-md'>
                                <img
                                    src={formulario.image
                                        ? `${process.env.REACT_APP_PHOTO_URI}company/logos/${formulario.image}`
                                        : logo}
                                    alt="logo"
                                    className='w-full py-4 px-4 rounded-lg dark:bg-white object-contain'
                                />
                            </div>
                        </div>
                        <div style={{ width: '24px' }}></div>
                    </div>
                </div>

                <div className='flex flex-col lg:flex-row justify-between items-start gap-4 py-2 px-4'>
                    <div className='w-full lg:w-2/3'>
                        <div className='bg-white dark:bg-[#292929] rounded-lg px-5 py-3 mb-4'>
                            <h1 className='text-xl font-semibold pb-3 text-turquesa'>Información general</h1>
                            <InfoRow label="Nombre de la empresa o entidad" value={formulario.company_name} />
                            <InfoRow label="Sector" value={formulario.business_sectors} capitalize />
                            <InfoRow label="Descripción de la empresa o entidad" value={formulario.about_us} longText />
                        </div>

                        <div className='bg-white dark:bg-[#292929] rounded-lg px-5 py-3'>
                            <h1 className='text-xl font-semibold py-2 text-turquesa'>Datos del representante</h1>
                            <InfoRow label="Nombres del representante" value={formulario.names} />
                            <InfoRow label="Apellidos del representante" value={formulario.lastnames} />
                        </div>
                    </div>

                    <div className='w-full lg:w-1/3'>
                        <div className='bg-white dark:bg-[#292929] rounded-lg px-5 py-4'>
                            <InfoIconRow icon={faPhone} label="Número de teléfono" value={formulario.phone} />
                            <InfoIconRow icon={faEnvelope} label="Correo electrónico" value={formulario.email} />
                            {renderDocumentInfo()}
                            <InfoIconRow icon={faUserGroup} label="Razón social" value={formulario.trade_name} />
                            <InfoIconRow icon={faLocationDot} label="Dirección" value={formulario.address} />
                        </div>

                        {/* {getSession().id !== 1 && ( */}
                        <div className='py-4 w-full'>
                            <Link to={id ? `/Organizaciones/Editar/${id ?? sesion.company.id}` : "/EditarOrganizacion"} className='block bg-turquesa w-full text-center rounded-lg py-3 px-3 text-white font-semibold hover:bg-turquesa-dark transition-colors'>
                                Actualizar datos
                            </Link>
                        </div>
                        {/* )} */}
                    </div>
                </div>
            </section>
        </MainThemeLayout>
    );
}

const InfoRow = ({ label, value, longText = false, capitalize = false }) => (
    <div className={`py-3 ${longText ? '' : 'flex flex-col md:flex-row md:items-center'}`}>
        <span className='text-sm font-semibold dark:text-white min-w-[200px]'>{label}:</span>
        <span className={`pl-2 font-normal dark:text-stone-400 ${longText ? 'block mt-1' : ''} ${capitalize ? 'capitalize' : ''}`}>
            {value || 'No especificado'}
        </span>
    </div>
);

const InfoIconRow = ({ icon, label, value }) => (
    <div className='flex items-start pb-4 last:pb-0'>
        <FontAwesomeIcon icon={icon} className="dark:text-white text-xl rounded-full w-6 h-6 pr-4 pt-1 text-turquesa flex-shrink-0" />
        <div>
            <h1 className='text-sm font-semibold dark:text-white'>{label}:</h1>
            <p className='text-sm font-normal dark:text-stone-400'>{value || 'No especificado'}</p>
        </div>
    </div>
);

export default PreviewCompanyProfile;